import { render, staticRenderFns } from "./FlowAssessmentsEditDialog.vue?vue&type=template&id=9a5a652a&"
import script from "./FlowAssessmentsEditDialog.vue?vue&type=script&lang=js&"
export * from "./FlowAssessmentsEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports